const UserCenterNewView = () => import("@views/user-center-new/user-center-new-view.vue");

export const userCenterNewRoutes = [
    {
        component: UserCenterNewView,
        name: "user_center_new",
        path: "novosti",
    },
];
